import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'orion';
import criticalIcon from '../../assets/images/critical.svg';
import infoIcon from '../../assets/images/info.svg';
import warningIcon from '../../assets/images/warning.svg';

var Severity = function Severity(_ref) {
  var severity = _ref.severity;

  switch (severity) {
    case 1:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        src: criticalIcon,
        size: "sm",
        muted: false,
        className: "oui-mr-2"
      }), "Critical");

    case 2:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        src: warningIcon,
        size: "sm",
        muted: false,
        className: "oui-mr-2"
      }), "Warning");

    case 3:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        src: infoIcon,
        size: "sm",
        muted: false,
        className: "oui-mr-2"
      }), "Information");

    default:
      return null;
  }
};

Severity.propTypes = {
  severity: PropTypes.number
};
export default Severity;